import { PhotoBtnCard } from '@playbooks/molecules/cards';

export const ThumbnailPhotoLinkCard = ({ thumbnail, loading, selected, onClick, className = '' }) => {
	return (
		<PhotoBtnCard
			icon='images'
			photo={thumbnail.thumbnail}
			title={thumbnail.name}
			loading={loading}
			active={selected.id === thumbnail.id}
			onClick={() => onClick(thumbnail)}
			className={className}
		/>
	);
};
